import api from "core/api/axiosInstance";
import {
  accesparkEntry,
  accesparkResult,
  parseAccesparkResponse,
  terminalDirection,
} from "../ciclosAccespark/model/accesparkModel";
import { normalizePlate } from "../creacionCiclo/model/cycleModel";
import { cycleRequestError } from "./cycleRequestError";
const requireAuth = () => {
  if (!localStorage.getItem("token"))
    throw new Error("Su sesión ha expirado. Inicie sesión nuevamente.");
};
const errorMessage = (error) =>
  error.response?.data?.message ||
  error.response?.data?.msm ||
  (error.request
    ? "No se pudo conectar. Verifique el historial antes de reintentar la operación."
    : error.message) ||
  "No se pudo completar la solicitud";
function listFrom(data, key) {
  const list = Array.isArray(data) ? data : data?.[key];
  if (!Array.isArray(list)) throw new Error("El servicio no devolvió una lista válida");
  return list;
}
async function getCycleCommerces(endpoint) {
  requireAuth();
  try {
    const { data } = await api.get(endpoint);
    return listFrom(data, "response")
      .filter((item) => item?.idcommerce != null && item.commerce?.trim())
      .map((item) => ({ id: String(item.idcommerce), name: item.commerce.trim() }))
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    throw new Error(errorMessage(error));
  }
}
export function getAccesparkCommerces() {
  return getCycleCommerces("/api/automatization/get-commerce-accespark");
}
export function getEzytecCommerces() {
  return getCycleCommerces("/api/automatization/get-readers-esytec");
}
export async function getAccesparkTerminals(commerceId) {
  requireAuth();
  if (!commerceId) throw new Error("Seleccione un comercio");
  try {
    const { data } = await api.get(
      `/api/automatization/get-commerce-terminals/${encodeURIComponent(commerceId)}`
    );
    return listFrom(data, "response")
      .filter((item) => item?.idterminal != null && item.terminalname?.trim())
      .map((item) => ({
        id: String(item.idterminal),
        name: item.terminalname.trim(),
        type: Number(item.type),
        commerceId: String(commerceId),
      }));
  } catch (error) {
    throw new Error(errorMessage(error));
  }
}
export async function getAccesparkCycles(type) {
  requireAuth();
  if (![2, 3, 4, 5].includes(Number(type))) throw new Error("Tipo de historial inválido");
  try {
    const { data } = await api.get(`/api/automatization/get-cycles/${type}`);
    return listFrom(data, "data");
  } catch (error) {
    throw new Error(errorMessage(error));
  }
}
export async function submitAccesparkCycle({ commerce, terminal, plate, date, time }) {
  requireAuth();
  let user;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch {
    throw new Error("No se pudo identificar al usuario de sesión");
  }
  let userId =
    user?.user?.id ??
    user?.user?.userId ??
    user?.user?.sub ??
    user?.id ??
    user?.userId ??
    user?.sub;
  // Algunos logins entregan el ID únicamente en el token. more identifica al
  // actor de auditoría y no debe usarse como usuario de esta operación.
  if (!userId || !String(userId).trim()) {
    try {
      const encoded = localStorage
        .getItem("token")
        .split(".")[1]
        .replace(/-/g, "+")
        .replace(/_/g, "/");
      const claims = JSON.parse(atob(encoded));
      userId = claims.id ?? claims.userId ?? claims.sub;
    } catch {
      // Un token opaco o inválido no permite recuperar el ID.
    }
  }
  if (!userId || !String(userId).trim())
    throw new Error("La sesión no contiene el ID del usuario. No se envió la operación.");
  if (!commerce?.id || !commerce.name || !terminal?.id || terminal.commerceId !== commerce.id)
    throw new Error("Seleccione una terminal del comercio actual");
  if (!terminalDirection(terminal.type))
    throw new Error("La terminal no tiene un tipo de operación válido");
  const normalizedPlate = normalizePlate(plate);
  if (!/^[A-Z]{3}\d{3}$/.test(normalizedPlate)) throw new Error("Use una placa como ABC123");
  const exit = accesparkEntry(date, time);
  if (new Date(exit.replace(" ", "T").replace(" -0500", "-05:00")).getTime() > Date.now())
    throw new Error("La fecha de la operación no puede ser futura");
  const payload = {
    commerce: commerce.name,
    exit,
    idterminal: Number(terminal.id),
    plate: normalizedPlate,
    userId,
  };
  try {
    const { data } = await api.post("/api/automatization/commerce/close-cycle", payload, {
      timeout: 30000,
    });
    const response = data?.response ?? data;
    const result = accesparkResult(response);
    const parsed = parseAccesparkResponse(response);
    const success =
      result.severity === "success" && data?.success !== false && data?.success !== "false";
    return {
      success,
      result,
      cycleId: parsed?.idCycle ?? parsed?.cycleId ?? null,
      message: `${result.label}: ${result.message}`,
      payloadSent: payload,
    };
  } catch (error) {
    const result = accesparkResult(error.response?.data?.response ?? error.response?.data);
    throw new Error(
      cycleRequestError(
        error,
        result.severity !== "info" ? `${result.label}: ${result.message}` : errorMessage(error)
      )
    );
  }
}
